import styled from 'styled-components';

export default function Loading() {
  return (
    <Container>
      <Inner>
        <Loader>
          <div></div>
          <div></div>
          <div></div>
        </Loader>
      </Inner>
    </Container>
  );
}

const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9;
`;

const Inner = styled.div`
  text-align: center;
  padding: 50px 60px;
  font-size: 2rem;
`;

export const Loader = styled.div`
  width: 3.5em;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;

  div {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background-color: ${(props) => props.theme.colors.orange500};
    animation: fade 0.8s ease-in-out alternate infinite;
  }

  div:nth-of-type(1) {
    animation-delay: -0.4s;
  }

  div:nth-of-type(2) {
    animation-delay: -0.2s;
  }

  @keyframes fade {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
`;
